module.exports = {"411082001":"建设路街道","411082002":"长兴路街道","411082003":"长社路街道","411082004":"金桥路街道","411082100":"和尚桥镇","411082101":"坡胡镇","411082102":"后河镇","411082103":"石固镇","411082104":"老城镇","411082105":"南席镇","411082106":"大周镇","411082107":"董村镇","411082108":"石象镇","411082109":"古桥镇","411082110":"增福镇","411082111":"佛耳湖镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411082.json
// module id = 1623
// module chunks = 0